import { Component, effect, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MThemeToggle, MThemeToggleService, THEME_MODE } from '@metromobilite/m-ui/components/m-theme-toggle';
import { NgDocNavbarComponent, NgDocRootComponent, NgDocSidebarComponent } from '@ng-doc/app';
import { NgDocThemeService } from '@ng-doc/app/services/theme';
import { MBadgesTypes } from '@metromobilite/m-ui/components/m-badges';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NgDocRootComponent, NgDocNavbarComponent, NgDocSidebarComponent, RouterOutlet, RouterLink, MThemeToggle],
})
export class AppComponent {
  private themeService: NgDocThemeService = inject(NgDocThemeService);
  private MThemeToggleService: MThemeToggleService = inject(MThemeToggleService);

  constructor() {
    effect(() => {
      this.themeService.set(this.MThemeToggleService.theme());
    });
  }

  protected readonly THEME_MODE = THEME_MODE;
  protected readonly MBadgesTypes = MBadgesTypes;
  protected readonly console = console;
}
